/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Tabs,
    Tab,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,        
    InputAdornment,     
    FormControl,         
    InputLabel,         
    Select,             
    MenuItem as SelectMenuItem  
} from '@mui/material';
import {
    Public,
    Add,
    NavigateNext,
    NavigateBefore,
    List as ListIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Block as BlockIcon,
    CheckCircle as ActivateIcon,
    Search as SearchIcon,   
    Clear as ClearIcon  
} from '@mui/icons-material';
import { useProvince } from 'hooks/api/terminology/province/useProvince';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { logger } from 'utils/environment/log';
import Swal from 'sweetalert2';
import AddEditProvince from './add';
import {
    ClampedText,
    CodeText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    formatConfigurationDate,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

const SearchSection = ({ searchTerm, setSearchTerm, searchField, setSearchField, onClearSearch, loading }) => {
    const searchFields = [
        { value: 'name', label: 'Province Name' },
        { value: 'id', label: 'Province ID' },
        { value: 'code', label: 'Province Code' },
        { value: 'createdBy', label: 'Created By' },
        { value: 'lastModifiedBy', label: 'Modified By' }
    ];

    return (
        <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Search Field</InputLabel>
                <Select value={searchField} label="Search Field" onChange={(e) => setSearchField(e.target.value)} disabled={loading}>
                    {searchFields.map((field) => (
                        <SelectMenuItem key={field.value} value={field.value}>
                            {field.label}
                        </SelectMenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                size="small"
                placeholder={`Search by ${searchFields.find((f) => f.value === searchField)?.label || 'Province Name'}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={loading}
                sx={{ flexGrow: 1, maxWidth: 400 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={onClearSearch} disabled={loading}>
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </Box>
    );
};

const ProvinceList = () => {
    const [activeTab, setActiveTab] = useState(0);
    
    // States for pagination and data
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(5);

    // Search states
    const [searchTerm, setSearchTerm] = useState('');
    const [searchField, setSearchField] = useState('name');

    // Hooks
    const { listProvince, updateProvince, deleteProvince, provinces } = useProvince();

    // Additional states
    const [editingProvince, setEditingProvince] = useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [provinceToDelete, setProvinceToDelete] = useState(null);
    const [toggleConfirmOpen, setToggleConfirmOpen] = useState(false);
    const [provinceToToggle, setProvinceToToggle] = useState(null);
    const [loading, setLoading] = useState(true);

    // Initial data fetch
    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            await listProvince(0, 100);
        } catch (error) {
            logger.error('Error fetching provinces:', error);
        } finally {
            setLoading(false);
        }
    };

    // Helper function to get nested object value
    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((current, key) => {
            return current && current[key] !== undefined ? current[key] : null;
        }, obj);
    };

    // Filter provinces based on search
    const getFilteredProvinces = () => {
        if (!searchTerm.trim()) {
            return provinces;
        }

        const searchLower = searchTerm.toLowerCase().trim();
        return provinces.filter((province) => {
            const fieldValue = getNestedValue(province, searchField);
            if (fieldValue === null || fieldValue === undefined) {
                return false;
            }
            return String(fieldValue).toLowerCase().includes(searchLower);
        });
    };

    const filteredProvinces = getFilteredProvinces();

    const handleClearSearch = () => {
        setSearchTerm('');
        setPage(0);
    };

    const handleEditClick = (province) => {
        setEditingProvince(province);
        setActiveTab(1);
    };

    const handleAddNew = () => {
        setEditingProvince(null);
        setActiveTab(1);
    };

    const handleDeleteClick = (province) => {
        setProvinceToDelete(province);
        setDeleteConfirmOpen(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await deleteProvince(provinceToDelete.id);
            await fetchInitialData();
            setDeleteConfirmOpen(false);
            setProvinceToDelete(null);
            Swal.fire({
                icon: 'success',
                title: 'Province Deleted',
                text: 'The province has been successfully deleted.',
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            logger.error('Error deleting province:', error);
            
            let errorMessage = 'Failed to delete the province. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            } else if (error.response && error.response.status === 409) {
                errorMessage = 'Cannot delete province. It may be in use by other records.';
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        }
    };

    const handleDeleteCancel = () => {
        setDeleteConfirmOpen(false);
        setProvinceToDelete(null);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setEditingProvince(null);
        }
    };

    const handleToggleActive = async (province) => {
        setProvinceToToggle(province);
        setToggleConfirmOpen(true);
    };

    const handleToggleConfirm = async () => {
        try {
            const updatedProvince = { ...provinceToToggle, isActive: !provinceToToggle.isActive };
            await updateProvince(provinceToToggle.id, updatedProvince);
            await fetchInitialData();
            setToggleConfirmOpen(false);
            setProvinceToToggle(null);
            Swal.fire({
                icon: 'success',
                title: provinceToToggle.isActive ? 'Province Deactivated' : 'Province Activated',
                text: `The province has been successfully ${provinceToToggle.isActive ? 'deactivated' : 'activated'}.`,
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            logger.error('Error toggling province status:', error);
            
            let errorMessage = 'Failed to update province status. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage
            });
        }
    };

    const handleToggleCancel = () => {
        setToggleConfirmOpen(false);
        setProvinceToToggle(null);
    };

    const handleProvinceSubmitted = () => {
        fetchInitialData();
        setActiveTab(0);
        setEditingProvince(null);
    };

    const renderProvincesList = () => (
        <Box sx={{ mt: 4 }}>
            <SearchSection
                searchTerm={searchTerm}
                setSearchTerm={(value) => {
                    setSearchTerm(value);
                    setPage(0);
                }}
                searchField={searchField}
                setSearchField={setSearchField}
                onClearSearch={handleClearSearch}
                loading={loading}
            />

            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    {searchTerm ? (
                        <>
                            Showing {filteredProvinces.length} of {provinces.length} provinces
                            {filteredProvinces.length > 0 && ` matching "${searchTerm}"`}
                        </>
                    ) : (
                        <>Total: {provinces.length} provinces</>
                    )}
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={handleAddNew}
                    sx={{
                        backgroundColor: globalColor,
                        '&:hover': {
                            backgroundColor: globalColor,
                            opacity: 0.9
                        }
                    }}
                >
                    Add New Province
                </Button>
            </Box>

            <Fade in timeout={1000}>
                <StyledTableContainer component={Paper}>
                    <Table size="small" sx={tableSx(880)}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 112 }}>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell sx={{ width: 112 }}>Code</TableCell>
                                <TableCell sx={{ width: 220 }}>Description</TableCell>
                                <TableCell sx={{ width: 122 }}>Created</TableCell>
                                <TableCell sx={{ width: 92 }}>Status</TableCell>
                                <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredProvinces.length > 0 ? (
                                filteredProvinces.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((province) => (
                                    <TableRow key={province.id}>
                                        <TableCell><CodeText>{province.id}</CodeText></TableCell>
                                        <TableCell>{province.name}</TableCell>
                                        <TableCell><CodeText>{province.code}</CodeText></TableCell>
                                        <TableCell><ClampedText>{province.description}</ClampedText></TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatConfigurationDate(province.createdAt)}</TableCell>
                                        <TableCell>
                                            <ConfigurationStatusChip active={province.isActive} />
                                        </TableCell>
                                        <TableCell align="center" sx={stickyActionCellSx}>
                                            <ConfigurationActionMenu
                                                label={province.name}
                                                actions={[
                                                    { label: 'Edit', icon: EditIcon, onClick: () => handleEditClick(province) },
                                                    {
                                                        label: province.isActive ? 'Deactivate' : 'Activate',
                                                        icon: province.isActive ? BlockIcon : ActivateIcon,
                                                        color: province.isActive ? '#b54708' : '#25643b',
                                                        onClick: () => handleToggleActive(province)
                                                    }
                                                ]}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        <Box sx={{ py: 4 }}>
                                            <Typography variant="body1" color="text.secondary">
                                                {searchTerm ? (
                                                    <>
                                                        No provinces found matching "{searchTerm}" in {searchField}
                                                        <Box sx={{ mt: 2 }}>
                                                            <Typography
                                                                variant="body2"
                                                                color="primary"
                                                                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                onClick={handleClearSearch}
                                                            >
                                                                Clear search to view all provinces
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                ) : (
                                                    'No provinces available'
                                                )}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <ConfigurationPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        total={filteredProvinces.length}
                        onPageChange={setPage}
                    />
                </StyledTableContainer>
            </Fade>
        </Box>
    );

    const renderToggleDialog = () => (
        <Dialog open={toggleConfirmOpen} onClose={handleToggleCancel}>
            <DialogTitle>
                {provinceToToggle?.isActive ? 'Deactivate Province' : 'Activate Province'}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to {provinceToToggle?.isActive ? 'deactivate' : 'activate'} the province "{provinceToToggle?.name}"?
                    {provinceToToggle?.isActive && ' This will make the province unavailable for use.'}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleToggleCancel}>Cancel</Button>
                <Button 
                    onClick={handleToggleConfirm} 
                    color={provinceToToggle?.isActive ? 'warning' : 'success'} 
                    variant="contained"
                >
                    {provinceToToggle?.isActive ? 'Deactivate' : 'Activate'}
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderDeleteDialog = () => (
        <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel}>
            <DialogTitle>Confirm Province Deletion</DialogTitle>
            <DialogContent>
                <Typography>Are you sure you want to delete the province "{provinceToDelete?.name}"? This action cannot be undone.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDeleteCancel}>Cancel</Button>
                <Button onClick={handleDeleteConfirm} color="error" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '1rem',
                            textTransform: 'none'
                        }
                    }}
                >
                    <Tab icon={<ListIcon />} iconPosition="start" label="Provinces List" />
                    <Tab icon={<Add />} iconPosition="start" label={editingProvince ? 'Edit Province' : 'Add New Province'} />
                </Tabs>
            </Box>

            {activeTab === 0 ? (
                renderProvincesList()
            ) : (
                <AddEditProvince
                    editingProvince={editingProvince}
                    onProvinceSubmitted={handleProvinceSubmitted}
                />
            )}
            
            {renderToggleDialog()}
            {renderDeleteDialog()}
        </Box>
    );
};

export default ProvinceList;
